import React, { useState } from "react";
import { Phone, MessageCircle, X, Mail } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const FloatingContact = () => {
  const { tr } = useLang();
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      {open && (
        <div className="flex flex-col gap-3 animate-fade-up">
          <a data-testid="fab-call" href="tel:+33788041772" className="flex items-center gap-3 bg-white shadow-xl rounded-full pl-4 pr-5 py-3 font-semibold text-ink border border-slate-100 hover:border-brand">
            <Phone className="w-5 h-5 text-brand" /> {tr.cta.call}
          </a>
          <a data-testid="fab-whatsapp" href="https://wa.me/33788041772" className="flex items-center gap-3 bg-white shadow-xl rounded-full pl-4 pr-5 py-3 font-semibold text-ink border border-slate-100 hover:border-brand">
            <MessageCircle className="w-5 h-5 text-green-600" /> WhatsApp
          </a>
          <a data-testid="fab-email" href="mailto:thibault.milhaud@gmail.com" className="flex items-center gap-3 bg-white shadow-xl rounded-full pl-4 pr-5 py-3 font-semibold text-ink border border-slate-100 hover:border-brand">
            <Mail className="w-5 h-5 text-accent2" /> {tr.cta.email}
          </a>
        </div>
      )}
      <button data-testid="fab-toggle" onClick={() => setOpen((v) => !v)} aria-label="Contact"
        className="w-16 h-16 rounded-full bg-accent2 hover:bg-accent2-hover text-white shadow-xl grid place-items-center transition-colors">
        {open ? <X className="w-7 h-7" /> : <MessageCircle className="w-8 h-8" />}
      </button>
    </div>
  );
};

export default FloatingContact;
